<template>
  <div v-if="show" v-loading="loading" class="duplicate-candidate-container" :class="hasResumeView ? 'has-resume-view' : ''">
    <el-table
      :data="orderCandidateList"
    >
      <el-table-column
        property="candidate_id"
        :min-width="hasResumeView ? '80px' : '100px'"
        :label="$t(`${i18nPrefix}.label.duplicateCandidate.id`)"
      ></el-table-column>
      <el-table-column
        property="name"
        :min-width="hasResumeView ? '90px' : '120px'"
        show-overflow-tooltip
        :label="$t(`${i18nPrefix}.label.duplicateCandidate.name`)"
      ></el-table-column>
      <el-table-column
        property="phone"
        :min-width="hasResumeView ? '110px' : '140px'"
        show-overflow-tooltip
        :label="$t(`${i18nPrefix}.label.duplicateCandidate.phone`)"
      ></el-table-column>
      <el-table-column
        property="email_address"
        :min-width="hasResumeView ? '160px' : '200px'"
        show-overflow-tooltip
        :label="$t(`${i18nPrefix}.label.duplicateCandidate.email`)"
      ></el-table-column>
      <el-table-column
        min-width="50px"
        class-name="operate-btn-container"
      >
        <template #default="{ row }">
          <el-button
            type="text"
            @click="handleViewBtnClick(row)"
          >
            {{ $t(`${i18nPrefix}.btn.viewDuplicateCandidate`) }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <RectLoading v-show="loading" class="loading"></RectLoading>
  </div>
</template>

<script>
import _ from 'lodash'
import mixin from './mixin'
import RectLoading from '@/components/loading/rectLoading.vue'

export default {
  props: {
    duplicateCandidateList: {
      type: Array,
      required: true
    },
    hasResumeView: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RectLoading
  },
  mixins: [mixin],
  data () {
    const i18nPrefix = 'admin.application.candidate'
    return {
      i18nPrefix,
      hasForm: false,
      stepData: {}
    }
  },
  computed: {
    orderCandidateList () {
      return _.sortBy(this.duplicateCandidateList, (candidate) => {
        if (_.includes(candidate.job_ids, Number(this.jobId))) {
          return -1
        }
        return 0
      })
    }
  },
  created () {

  },
  methods: {
    handleViewBtnClick (row) {
      const link = `/v-admin/talent-pool/candidate/profile?candidate_id=${row.candidate_id}`
      window.open(link)
    },
    async setStepDataToCandidateInfo () {

    },
    async getStepData () {

    }
  }
}
</script>

<style lang="scss" scoped>
.duplicate-candidate-container {
  position: relative;
  padding-left: 20px;

  ::v-deep {
    .el-table {
      th.el-table__cell,
      tr {
        background: #f7f7f7;
      }

      .operate-btn-container {
        text-align: center;

        .el-button {
          padding: 0;
        }
      }
    }
  }

  .loading {
    position: absolute;
  }
}

.has-resume-view {
  .el-table {
    width: 90%;
    font-size: 12px;
    margin-left: 34px;
  }
  .operate-btn-container {
    .el-button {
      font-size: 12px;
    }
  }
}
</style>
